import styled from 'styled-components';
import { WebLink2, colors, spacing } from 'ui/theme';

export const AnnouncementsContainer = styled.div`
  margin: 0 -${spacing.layoutLRPadding};
  position: relative;
`;

export const DocumentationLink = styled(WebLink2)`
  align-items: center;
  color: ${colors.link};
  display: inline-flex;
  text-decoration: none;
`;
